import { render } from "./Accordion.vue?vue&type=template&id=53a68320&scoped=true"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"

import "./Accordion.vue?vue&type=style&index=0&id=53a68320&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-53a68320"

export default script